// removed by extract-text-webpack-plugin
module.exports = {"btn-wishlist":"_3nwFc3iwZjfubmzu2ib5As","btn-wishlist-on":"_135RfuIJAWzLd0CzJm3CZm","container":"xSW1iimlkQohcUeOW-2rs","mobile-hide-label":"rSGLuSGCWhNQkV1ufLbjC _13UyNN6lRQaIE4nGDzE2-d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/General/Buttons/WishlistButton.scss
// module id = 1159
// module chunks = 47